/* ============================================
   MOBILE MEGA MENU - THEORIC
   State management, product fetching, carousel
   ============================================ */

(function () {
  'use strict';

  const ANIM_DURATION = 350;
  const productsCache = {};

  function initMobileMegaMenu() {
    const menu = document.getElementById('SidePopupMenu');
    if (!menu) return;

    const overlay = menu.querySelector('.mobile-megamenu__overlay');
    const closeBtns = menu.querySelectorAll('[data-close]:not(.mobile-megamenu__overlay)');
    const stateMain = menu.querySelector('[data-state="main"]');
    const stateDetail = menu.querySelector('[data-state="detail"]');
    const backBtn = menu.querySelector('[data-menu-back]');
    const expandBtns = menu.querySelectorAll('[data-menu-expand]');

    // Detail elements
    const breadcrumbTitle = document.getElementById('megamenu-breadcrumb-title');
    const collectionTitle = document.getElementById('megamenu-collection-title');
    const collectionDesc = document.getElementById('megamenu-collection-desc');
    const carousel = document.getElementById('megamenu-carousel');
    const carouselNext = document.getElementById('megamenu-carousel-next');
    const bannerImg = document.getElementById('megamenu-collection-banner-img');

    // Open menu
    function openMenu() {
      menu.classList.remove('hidden');
      menu.setAttribute('aria-hidden', 'false');
      // Force reflow
      void menu.offsetWidth;
      menu.classList.add('open');
      // Ensure main state is active on open
      showState('main');
      if (typeof scrollLock !== 'undefined') {
        scrollLock.lock();
      }
    }

    // Close menu
    function closeMenu() {
      menu.classList.remove('open');
      setTimeout(() => {
        menu.classList.add('hidden');
        menu.setAttribute('aria-hidden', 'true');
        // Reset to main state
        resetToMain();
        if (typeof scrollLock !== 'undefined') {
          scrollLock.unlock();
        }
      }, ANIM_DURATION + 50);
    }

    // State transitions
    function showState(state) {
      if (state === 'main') {
        stateDetail.classList.remove('is-active');
        stateDetail.classList.add('is-exiting');
        setTimeout(() => {
          stateDetail.classList.remove('is-exiting');
        }, 300);
        stateMain.classList.remove('is-exiting');
        stateMain.classList.add('is-active');
      } else if (state === 'detail') {
        stateMain.classList.remove('is-active');
        stateMain.classList.add('is-exiting');
        setTimeout(() => {
          stateMain.classList.remove('is-exiting');
        }, 300);
        stateDetail.classList.remove('is-exiting');
        stateDetail.classList.add('is-active');
      }
    }

    function resetToMain() {
      stateMain.classList.add('is-active');
      stateMain.classList.remove('is-exiting');
      stateDetail.classList.remove('is-active', 'is-exiting');
      // Clear carousel
      if (carousel) carousel.innerHTML = '';
      if (bannerImg) {
        bannerImg.src = '';
        bannerImg.classList.remove('loaded');
      }
    }

    // Fetch products for a collection
    async function fetchProducts(handle) {
      if (productsCache[handle]) return productsCache[handle];

      try {
        const resp = await fetch(`/collections/${handle}/products.json?limit=10`);
        if (!resp.ok) throw new Error('Fetch failed');
        const data = await resp.json();
        productsCache[handle] = data.products;
        return data.products;
      } catch (err) {
        console.warn('Could not fetch products for', handle, err);
        return [];
      }
    }

    // Render product cards into carousel
    function renderProducts(products) {
      if (!carousel) return;
      carousel.innerHTML = '';
      carousel.scrollLeft = 0;

      products.forEach(product => {
        const imgSrc = product.images && product.images[0]
          ? product.images[0].src
          : '';
        const price = product.variants && product.variants[0]
          ? parseFloat(product.variants[0].price).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
          : '';

        const isBrinde = ['the-icon-bag', 'the-wild-bag', 'the-pop-bag'].includes(product.handle) ||
          (product.tags && (product.tags.includes('brinde') || product.tags.includes('Brinde')));

        let priceHtml = '';
        if (!isBrinde && product.variants && product.variants[0]) {
          const variantPrice = parseFloat(product.variants[0].price);
          const compareAtPrice = parseFloat(product.variants[0].compare_at_price);
          const formattedPrice = variantPrice.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

          if (compareAtPrice && compareAtPrice > variantPrice) {
            const formattedCompare = compareAtPrice.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
            const discount = Math.round(((compareAtPrice - variantPrice) / compareAtPrice) * 100);
            priceHtml = `
              <div class="mobile-megamenu__product-price-wrapper">
                <span class="mobile-megamenu__product-price">${formattedPrice}</span>
                <span class="mobile-megamenu__product-price--compare">${formattedCompare}</span>
                ${discount > 0 ? `<span class="mobile-megamenu__product-discount">-${discount}%</span>` : ''}
              </div>
            `;
          } else {
            priceHtml = `<span class="mobile-megamenu__product-price">${formattedPrice}</span>`;
          }
        }

        const card = document.createElement('a');
        card.href = `/products/${product.handle}`;
        card.className = 'mobile-megamenu__product';
        card.innerHTML = `
          <div class="mobile-megamenu__product-image-wrap">
            ${imgSrc ? `<img class="mobile-megamenu__product-img" src="${imgSrc}" alt="${product.title}" loading="lazy">` : ''}
          </div>
          <div class="mobile-megamenu__product-info">
            <span class="mobile-megamenu__product-name">${(window.theoricNomes && window.theoricNomes[product.handle]) || product.title}</span>
            ${priceHtml}
          </div>
        `;
        carousel.appendChild(card);
      });

      updateCarouselArrow();
    }

    // Carousel scroll arrow visibility
    function updateCarouselArrow() {
      if (!carousel || !carouselNext) return;
      const isScrollable = carousel.scrollWidth > carousel.clientWidth;
      const isAtEnd = carousel.scrollLeft + carousel.clientWidth >= carousel.scrollWidth - 10;

      if (!isScrollable || isAtEnd) {
        carouselNext.classList.add('is-hidden');
      } else {
        carouselNext.classList.remove('is-hidden');
      }
    }

    // Open collection detail
    async function openCollectionDetail(btn) {
      const title = btn.dataset.linkTitle || btn.dataset.collectionTitle || '';
      const handle = btn.dataset.collectionHandle || '';
      const desc = btn.dataset.collectionDescription || '';
      const image = btn.dataset.collectionImage || '';
      const hasChildren = btn.dataset.hasChildren === 'true';

      // If the item has children but is NOT a collection, it might still be expandable
      // We need to find child collections and show them as products
      let productsToShow = [];

      if (handle) {
        // It's a collection - fetch its products
        if (breadcrumbTitle) breadcrumbTitle.textContent = title;
        if (collectionTitle) collectionTitle.textContent = title;
        if (collectionDesc) collectionDesc.textContent = desc;

        // Load banner image
        if (bannerImg && image) {
          bannerImg.classList.remove('loaded');
          bannerImg.src = image;
          bannerImg.alt = title;
          bannerImg.onload = () => bannerImg.classList.add('loaded');
        }

        showState('detail');
        productsToShow = await fetchProducts(handle);
        renderProducts(productsToShow);
      } else if (hasChildren) {
        // Not a collection but has children - find the JSON data
        const parentHandle = title.toLowerCase().replace(/\s+/g, '-').replace(/[^\w-]/g, '');
        const jsonEl = menu.querySelector(`.mobile-megamenu__children-data[data-parent="${parentHandle}"]`);

        if (jsonEl) {
          try {
            const data = JSON.parse(jsonEl.textContent);

            if (breadcrumbTitle) breadcrumbTitle.textContent = data.title;
            if (collectionTitle) collectionTitle.textContent = data.title;
            if (collectionDesc) collectionDesc.textContent = '';

            // Find the first child that has a collection image for the banner
            let bannerImageUrl = '';
            let bannerDesc = '';
            for (const child of data.children) {
              if (child.isCollection && child.collectionImage) {
                bannerImageUrl = child.collectionImage;
                bannerDesc = child.collectionDescription || '';
                break;
              }
            }

            if (bannerDesc && collectionDesc) {
              collectionDesc.textContent = bannerDesc;
            }

            if (bannerImg && bannerImageUrl) {
              bannerImg.classList.remove('loaded');
              bannerImg.src = bannerImageUrl;
              bannerImg.alt = data.title;
              bannerImg.onload = () => bannerImg.classList.add('loaded');
            }

            showState('detail');

            // Collect products from all child collections
            const allProducts = [];
            for (const child of data.children) {
              if (child.isCollection && child.collectionHandle) {
                const products = await fetchProducts(child.collectionHandle);
                allProducts.push(...products);
              }
            }

            // Deduplicate by handle
            const seen = new Set();
            const uniqueProducts = allProducts.filter(p => {
              if (seen.has(p.handle)) return false;
              seen.add(p.handle);
              return true;
            });

            renderProducts(uniqueProducts);
          } catch (e) {
            console.warn('Failed to parse children data', e);
            // Fallback: just navigate
            if (btn.dataset.linkUrl) window.location.href = btn.dataset.linkUrl;
          }
        } else {
          // No JSON data found, navigate directly
          if (btn.dataset.linkUrl) window.location.href = btn.dataset.linkUrl;
        }
      }
    }

    // --- Event Listeners ---

    // Open button (hamburger in header)
    const openBtns = document.querySelectorAll('[data-open-menu]');
    openBtns.forEach(btn => btn.addEventListener('click', openMenu));

    // Close
    if (overlay) overlay.addEventListener('click', closeMenu);
    closeBtns.forEach(btn => btn.addEventListener('click', closeMenu));

    // Back button
    if (backBtn) {
      backBtn.addEventListener('click', () => showState('main'));
    }

    // Expand buttons (collection/parent items with +)
    expandBtns.forEach(btn => {
      btn.addEventListener('click', () => openCollectionDetail(btn));
    });

    // Carousel scroll
    if (carouselNext && carousel) {
      carouselNext.addEventListener('click', () => {
        carousel.scrollBy({ left: 200, behavior: 'smooth' });
      });

      carousel.addEventListener('scroll', updateCarouselArrow, { passive: true });
    }

    // Escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && menu.classList.contains('open')) {
        closeMenu();
      }
    });
  }

  // Initialize
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMobileMegaMenu);
  } else {
    initMobileMegaMenu();
  }
})();
